import { render } from "./HomepageLightfortheworld.vue?vue&type=template&id=20748597&scoped=true"
import script from "./HomepageLightfortheworld.vue?vue&type=script&lang=js"
export * from "./HomepageLightfortheworld.vue?vue&type=script&lang=js"

import "./HomepageLightfortheworld.vue?vue&type=style&index=0&id=20748597&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20748597"]])

export default __exports__